import "./styles.less";

export const Header = () => {
    return (
        <div className="events-header">
            <h1 className="text">
                <span className="white">PRÓXIMOS EVENTOS</span>
                <span className="orange">INFOCASAS</span>
            </h1>
        </div>
    )
}